<script>
import { iIcon, iAccordionItem, iAccordionItemSizes } from '@inscribe/signal';
import InfoIcon from '@/V2/components/InfoIcon';
import StatusCard from '@/V2/components/status/StatusCard.vue';
import { Statuses } from '@/V2/components/status/utils';
import {
  mapDocumentToRiskLevel,
  mapDocumentToStatus,
} from '@/V2/documents/document-view/document-review-agent/utils';

export default {
  components: {
    iIcon,
    iAccordionItem,
    InfoIcon,
    StatusCard,
  },
  props: {
    document: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      iAccordionItemSizes,
      mapDocumentToRiskLevel,
      mapDocumentToStatus,
      Statuses,
    };
  },
  methods: {
    openTrustScoreDetails() {
      this.$emit('open-trust-score-details');
    },
  },
};
</script>

<template>
  <i-accordion-item
    class="document-review-agent-no-runs"
    :mount-open="true"
    title="Summary"
    :no-background="true"
    :size="iAccordionItemSizes.LARGE"
  >
    <!-- title extra content -->
    <template #extra-title-content>
      <info-icon
        class="i-mr-4"
        title="Summary"
        description="Summarizes the overall risk level based on any identified fraud signals."
      />
    </template>

    <div
      class="score-box d-flex flex-column i-gap-4 i-mb-8"
      @click="openTrustScoreDetails"
    >
      <status-card
        :state="mapDocumentToStatus(document)"
        :label="mapDocumentToRiskLevel(document)"
        :score="document?.trust_score"
      ></status-card>
    </div>
  </i-accordion-item>
</template>

<style lang="scss" scoped>
.document-review-agent-no-runs {
  .score-box {
    cursor: pointer;
  }
}
</style>
